import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function checkOTPCode (otpCode) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLogin)
      }, 500)
    })
  } else {
    const req = {
      url: 'api/login/otpCheck',
      method: 'POST',
      data: {
        OTPCode: otpCode,
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { checkOTPCode }
